'use client'
import { type PropsWithChildren } from 'react'
import { atom, useAtomValue } from 'jotai'
import { atomFamily, useHydrateAtoms } from 'jotai/utils'
import { useProductData } from '@/components/ProductData/ProductDataProvider'
import type { ReviewsMetadata } from './memberReviews.types'

const productReviewsMetadataAtomFamily = atomFamily(() => atom<ReviewsMetadata | null>(null))

type Props = PropsWithChildren<{ productReviewsMetadata: ReviewsMetadata | null }>

export const ProductReviewsMetadataProvider = ({ children, productReviewsMetadata }: Props) => {
  const productData = useProductData()
  useHydrateAtoms([[productReviewsMetadataAtomFamily(productData.name), productReviewsMetadata]])
  return children
}

export const useProductReviewsMetadata = () => {
  const productData = useProductData()
  return useAtomValue(productReviewsMetadataAtomFamily(productData.name))
}
